export const permissions = [
  {_id: 300, label: 'Basic User', value: 'NormalUser', visible: true},
  {_id: 200, label: 'Super User', value: 'SuperUser', visible: true},
  {_id: 100, label: 'Super Admin', value: 'SuperAdmin', visible: true},
  {_id: 0, label: 'Manage Admin', value: 'ManageAdmin', visible: false},
];